module.exports = "<p>\n  user works!\n</p>\n"